module.exports = __webpack_public_path__ + "img/VISA-m.f99cf98b.png";